export default "__VITE_ASSET__4d21b2a9__"